import { Chains, chains, ChainType } from 'services/wallet-service';

export const getExplorerUrl = (addressOrTxHash: string, network: Chains, chainType: ChainType) =>
  `${chains[network][chainType].blockExplorerUrl}/tx/${addressOrTxHash}`;
